import { render, staticRenderFns } from "./LandfillManagement.vue?vue&type=template&id=4082bd24&scoped=true"
import script from "./LandfillManagement.vue?vue&type=script&lang=js"
export * from "./LandfillManagement.vue?vue&type=script&lang=js"
import style0 from "./LandfillManagement.vue?vue&type=style&index=0&id=4082bd24&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082bd24",
  null
  
)

export default component.exports